import type { FC, ReactNode } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { Trans } from 'react-i18next';

import {
  NoOptionsItemContainer,
  NoOptionsItemIconContainer,
} from '@shared/ui-kit/selects/MuiSelect/NoOptionsMessage/components/NoOptionsItem/NoOptionsItem.style';

type PropsType = {
  onClick: () => void;
  icon: ReactNode;
  buttonText: string;
};

export const NoOptionsItem: FC<PropsType> = ({ onClick, icon, buttonText }) => {
  const theme = useTheme();

  return (
    <NoOptionsItemContainer onClick={onClick}>
      <NoOptionsItemIconContainer>{icon}</NoOptionsItemIconContainer>

      <Typography variant="s2" sx={{ color: theme.palette.case.neutral.n600 }}>
        <Trans
          defaults={buttonText}
          components={{
            greenText: <Box component="span" sx={{ color: theme.palette.case.aquamarine.a700 }} />,
          }}
        />
      </Typography>
    </NoOptionsItemContainer>
  );
};
